import { Component, Input } from '@angular/core';
import { TvlFile } from '../../models/file.model';
import { FileOrImageSelectorComponent } from '../../base/file-or-image-selector.component';

@Component({
    selector: 'tvcore-file-selector',
    templateUrl: './file-selector.component.html',
    styleUrls: ['./file-selector.component.scss'],
    standalone: false
})
export class FileSelectorComponent extends FileOrImageSelectorComponent<TvlFile> {
	@Input()
	type: string;

	override get currentFiles(): TvlFile[] {
		return super.currentFiles.filter((f) => f.type === this.type);
	}

	protected override emitUpload(file: File) {
		this.add.emit({
			id: `${file.lastModified}-${file.name}`,
			file,
			type: this.type,
		});
	}

	protected override fileAlreadyExists(file: File): boolean {
		return !!(this.files || []).find((f) => f.file.name === file.name);
	}
}
